<template>
  <div>
    <el-dialog
        v-el-drag-dialog
        :visible.sync="dialogVisible"
        :close-on-click-modal="false"
        title="跟踪信息"
        class="customer-edit"
        width="1000px"
        top="10vh"
        url="sd/so"
        @close="$reset('form')">
      <div style="line-height: 35px; height: 35px;">
        <div style="width: 34%; float:left;">
          <span>调整交期：</span>
          <el-date-picker
              v-model="value1"
              type="date"
              placeholder="选择日期"/>
        </div>
        <div style="width: 33%;  float:left;">
          <span>操作人：</span>
          <span>xx</span>
        </div>
        <div style="width: 33%;  float:left;">
          <span>操作时间：</span>
          <span>xx</span>
        </div>
      </div>
      <div style="clear: both; margin: 15px 0px;" class="block">
        <span>详情：</span>
        <el-input type="textarea"/>
      </div>
      <div>
        发货单:
      </div>
      <el-table
          ref="refTable"
          :data="tableData"
          style="width: 100%;">
        <el-table-column
            label="选择"
            width="120"/>
        <el-table-column
            label="发货单号"/>
        <el-table-column
            label="发货日期"
            width="150"/>
        <el-table-column
            label="状态"/>
      </el-table>
      <div style="width: 100%; height: 1px; border: 1px solid #eeeeee;"/>
      <div style="text-align: right; margin: 10px;"> <el-button type="primary">保存</el-button></div>
    </el-dialog>
  </div>
</template>

<script>
  export default {
    name: "SalesOrderTrace",
    data() {
      return {
        value1: "",
        desc: "",
        dialogVisible: false,
        tableData: [],
        activeName: "first",
        purchase: {
          pkid:"",
        },
      };
    },
    methods: {
      open(id) {
        console.log(id);
        this.purchase.pkid = id;
        this.dialogVisible = true;
        // this.getData();
      },
    },
  };
</script>

<style scoped>

</style>